import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {TranslateModule} from '@ngx-translate/core';

import {ModalModule} from '../../modal/modal.module';
import {DropdownTreeviewModule} from '../tree-multi-select/dropdown-treeview.module';
import {AddFieldsModalComponent} from './add-fields-modal.component';

@NgModule({
  declarations: [AddFieldsModalComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ModalModule,
    DropdownTreeviewModule
  ],
  exports: [AddFieldsModalComponent]
})
export class AddFieldsModalModule {}
